import React from 'react';
import { InputNumber } from 'antd';

const AddonAfterNumberInput = ({ addonAfter, value, onChange, onBlur, placeholder }) => {
  return (
    <div className="addon-after-numberInput">
      <InputNumber value={value} onChange={onChange} onBlur={onBlur} placeholder={placeholder} />
      {addonAfter ? (
        <div className="addon-after-numberInput__addonAfter">
          <div>{addonAfter}</div>
        </div>
      ) : null}
    </div>
  );
};

export default AddonAfterNumberInput;
